import React from 'react'

import { Tab } from 'components'
import { useTabs } from 'hooks'
import { TabsProvider } from 'hooks/useTabs/provider'

import ValidacaoTecnica from './components/ValidacaoTecnica'
import Jobs from './components/Jobs/Jobs'

const ParametrizacaoComponent: React.FC = () => {
  const { tabs, handleChangeTab, selectedTab } = useTabs([
    'JOBS',
    'Validação Técnica'
  ])

  return (
    <>
      <Tab
        tabs={tabs}
        value={selectedTab.position}
        handleChange={handleChangeTab}
      />
      {selectedTab.position === 0 && <Jobs />}
      {selectedTab.position === 1 && <ValidacaoTecnica />}
    </>
  )
}

const Parametrizacao: React.FC = () => {
  return (
    <TabsProvider>
      <ParametrizacaoComponent />
    </TabsProvider>
  )
}

export default Parametrizacao
